import ButtonBorderedSmall from './Buttons/ButtonBorderedSmall';
import ButtonFilledSmall from './Buttons/ButtonFilledSmall';
import { MODEL_STATUSES } from '../../utils/constants';
import { ModelStatuses } from '../../utils/enums';
import { Media } from '../../types/product';
export interface ProductCardProps {
    fsn: string;
    modelStatus?: string;
    approved?: boolean;
    imageUrl?: string;
    buttontext?: string;
    primaryButtonAction: any;
    secondaryButtonAction: any;
    iconUrl?: string;
    isVendor: boolean;
    medias?: Media[];
}

const ProductCard = ({ modelStatus, imageUrl, fsn, approved, medias, isVendor, primaryButtonAction, secondaryButtonAction }: ProductCardProps) => {
    const disableBtn = modelStatus === ModelStatuses.CREATION_IN_PROGRESS || medias?.length === 0;
    return (
        <div className=" bg-white shadow-sm rounded-lg flex ">
            <div className=" w-2/5 flex items-center">
                <img src={imageUrl} className="object-contain p-4" alt={fsn} />
            </div>
            <div className=" p-5 w-full relative">
                <p className=" text-base text-gray-500 dark:text-gray-300 uppercase">fsn</p>
                <h3 className=" text-lg text-gray-700 font-bold dark:text-white mb-5">{fsn}</h3>

                <p className=" text-base text-gray-500 dark:text-gray-300 uppercase">status</p>
                <h3 className=" text-lg text-gray-700 font-bold dark:text-white mb-5">{modelStatus && MODEL_STATUSES[modelStatus]}</h3>
                {modelStatus && modelStatus === ModelStatuses.APPROVED && (
                    <div className=" bg-approved-green flex items-center py-1 pl-1 pr-3 absolute top-4 right-4 rounded-full ">
                        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9.96477 0.277588C4.99465 0.277588 0.960938 4.63314 0.960938 9.99981C0.960938 15.3665 4.99465 19.722 9.96477 19.722C14.9349 19.722 18.9686 15.3665 18.9686 9.99981C18.9686 4.63314 14.9349 0.277588 9.96477 0.277588ZM7.52473 14.1706L4.29236 10.6804C3.94121 10.3012 3.94121 9.6887 4.29236 9.30953C4.6435 8.93037 5.21075 8.93037 5.5619 9.30953L8.164 12.1095L14.3586 5.42064C14.7098 5.04148 15.277 5.04148 15.6282 5.42064C15.9793 5.79981 15.9793 6.41231 15.6282 6.79148L8.79427 14.1706C8.45213 14.5498 7.87588 14.5498 7.52473 14.1706Z"
                                fill="white"
                            />
                        </svg>
                        <span className="text-xs font-normal text-white ml-1">Approved</span>
                    </div>
                )}
                <div className="flex mt-7  justify-end gap-4 ">
                    <ButtonBorderedSmall fullWidth label={isVendor ? 'Check Feedback' : 'Review Model'} disabled={disableBtn} onClick={secondaryButtonAction} />

                    <ButtonFilledSmall fullWidth label={isVendor ? 'Update File' : 'Download Model '} disabled={!isVendor && disableBtn} onClick={primaryButtonAction} />
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
